/** Add native lazy loading to CMS menu markup before SSR emits its image URLs. */
export const lazyMenuImages = (html: unknown): string => {
  if (typeof html !== 'string') return '';

  return html.replace(/<img\b[^>]*>/gi, (tag) => {
    const attributes = tag.replace(/\s(?:loading|decoding|fetchpriority)\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, '');
    return attributes.replace(/^<img\b/i, '<img loading="lazy" decoding="async" fetchpriority="low"');
  });
};
